import React from "react";
import DTHero from "../components/Dhruvtara/hero";
import DCta from "../components/Dhruvtara/cta";
import DPlus from "../components/Dhruvtara/plus";
import DVideo from "../components/Dhruvtara/videos";
import DCards from "../components/Dhruvtara/cards";
import DTMarquee from "../components/Dhruvtara/dt-marquee";

export default function VittVichaar() {
  return (
    <>
      <div className="py-12 px-8">
        <DTHero />
      </div>
      <DTMarquee />
      <DPlus />
      <DVideo />
      <DCards />
      <DCta />
    </>
  );
}
